/**
 * WMS Purchase Order Types
 * Shared between backend-wms and mobile-app
 *
 * DRY Compliance: Single source for all purchase order enums
 */

/**
 * Status of a purchase order
 */
export enum PurchaseOrderStatus {
  DRAFT = 'DRAFT',
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  PARTIALLY_RECEIVED = 'PARTIALLY_RECEIVED',
  FULLY_RECEIVED = 'FULLY_RECEIVED',
  CANCELLED = 'CANCELLED',
}

/**
 * Status labels for UI display
 */
export const PurchaseOrderStatusLabels: Record<PurchaseOrderStatus, string> = {
  [PurchaseOrderStatus.DRAFT]: 'Draft',
  [PurchaseOrderStatus.SUBMITTED]: 'Submitted',
  [PurchaseOrderStatus.APPROVED]: 'Approved',
  [PurchaseOrderStatus.PARTIALLY_RECEIVED]: 'Partially Received',
  [PurchaseOrderStatus.FULLY_RECEIVED]: 'Fully Received',
  [PurchaseOrderStatus.CANCELLED]: 'Cancelled',
};

/**
 * Color schemes for status badges (Chakra UI v3 compatible)
 */
export const PurchaseOrderStatusColors: Record<PurchaseOrderStatus, string> = {
  [PurchaseOrderStatus.DRAFT]: 'gray',
  [PurchaseOrderStatus.SUBMITTED]: 'blue',
  [PurchaseOrderStatus.APPROVED]: 'teal',
  [PurchaseOrderStatus.PARTIALLY_RECEIVED]: 'yellow',
  [PurchaseOrderStatus.FULLY_RECEIVED]: 'green',
  [PurchaseOrderStatus.CANCELLED]: 'red',
};
